import React from 'react';
import {
	Grid,
	Typography,
	Paper,
	Table,
	TableBody,
	TableRow,
	TableCell,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import authBgImg from 'assets/bgImg1.png';

const useStyles = makeStyles(() => ({
	criteriaText: {
		fontFamily: 'Poppins',
	},
	attention: {
		color: '#f50057',
		textDecoration: 'underline',
		fontWeight: 'bold',
		fontFamily: 'Poppins',
		paddingTop: "20px"
	},
}));

const Criteria = () => {
	const { t } = useTranslation();
	const classes = useStyles();

	const requirements = [
		{ requirement: `${t('requirement-one')}` },
		{ requirement: `${t('requirement-two')}` },
		// { requirement: `${t('requirement-three')}` },
		{ requirement: `${t('requirement-four')}` },
		// { requirement: `${t('requirement-five')}` },
	];
	return (
		<div
    // style={{
    //   backgroundImage: `url(${authBgImg})`,
    //   backgroundRepeat: 'no-repeat',
    //   backgroundSize: 'cover'
    // }}
    >
			<Paper
				elevation={10}
				style={{
					backgroundColor: 'rgb(22 39 25 / 9%)',
					marginTop: 10,
					padding: '20px',
					color: 'white',
				}}
			>
				<Grid container direction='column' spacing={2}>
					<Grid item>
						<Typography
							variant='h5'
							align='center'
							gutterBottom={true}
							className={`${classes.criteriaText} `}
							style={{
								color: '#8DC63F',
							}}
						>
							{t('requirements')}
						</Typography>
						<Table>
							<TableBody >
								{requirements.map(({ requirement }, index) => (
									<div key={index} className="d-flex py-1" >
										<CheckCircleOutlineIcon
												style={{
												color: '#8DC63F',
								 			}}
										/>
										<label className='px-1'>{requirement}</label>
									</div>
								))}
							</TableBody>
						</Table>
						<label className={classes.attention}>
							{t('attention')}:
						</label>
						<p className={classes.criteriaText}>
							{t('attention-text')}
						</p>
					</Grid>
					<Grid item>
						<label className={classes.criteriaText}>
							{t('start-journey')}
						</label>
					</Grid>
				</Grid>
			</Paper>
		</div>
	);
};

export default Criteria;
